import React from 'react';
import { Box, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
    },
}));

export const PlansContainer = ({ children }: { children: React.ReactNode }) => {
    const classes = useStyles();

    return <Box className={classes.root}>{children}</Box>;
};
